import React,{useState} from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";

const Resolved = ({ show, onClose }) => {
    const staff = [
        { value: "1", label: "Siva Sakthi", },
        { value: "2", label: "Banu Priya" },
        { value: "3", label: "Deepak Kumar" },
    ];
    const [selectedOption, setSelectedOption] = useState(null);
    return (
        <Modal show={show} onHide={onClose} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Resolve Reason</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row'>
                        <div className="col-lg-12">
                            <div className="row mb-2">
                                <label className="col-3 text-black fs-7">Date</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-8 text-danger fs-6 fw-bold">29-Jan-2025</label>
                            </div>
                            <div className="row mb-2">
                                <label className="col-3 text-black fs-7">Subscriber</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-8 text-black fs-6">Raghavan</label>
                            </div>
                            <div className="row mb-2">
                                <label className="col-3 text-black fs-7">Phone No</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-8 text-black fs-6">9803254464
                                </label>
                            </div>
                            <div className="row mb-2">
                                <label className="col-3 text-black fs-7">Complaint</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-8 text-black fs-6">
                                    <Badge bg="success" className='text-white fs-7 py-0 px-1'>
                                        <span>Food / Taste</span>
                                    </Badge>
                                </label>
                            </div>
                            <div className="row mb-2">
                                <label className="col-3 text-black fs-7">Package</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-8 text-black fs-6">
                                    <span className='me-2'>Break Fast</span>
                                    <span>(Mini)</span>
                                </label>
                            </div>
                            <div className="row mb-2">
                                <label className="col-3 text-black fs-7">Reason</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-8 text-black fs-6">The food tasted bland and lacked the expected flavor, leaving much to be desired	</label>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Reason" defaultValue={""} />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Resolved By<span className="required">*</span></label>
                            <Select placeholder='Select Staff'
                                defaultValue={selectedOption}
                                onChange={setSelectedOption}
                                options={staff}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Resolved</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Resolved;
